<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">凭证字</span></div>
    <div class="margin-top margin-left">
      <Button color="primary" @click="showForm=true">新增</Button>
    </div>
    <div class="h-panel-body">
      <vxe-table :data="datas" :border="true">
        <vxe-column title="凭证字" field="word"></vxe-column>
        <vxe-column title="打印标题" field="printTitle" :width="120"></vxe-column>
        <vxe-column title="是否默认" :width="100">
          <template #default="{row}">
            {{ row.isDefault ? '是' : '否' }}
          </template>
        </vxe-column>
        <vxe-column title="操作" :width="100" align="center">
          <template #default="{row}">
            <div class="actions" v-if="!row.isDefault">
              <span @click="edit(row)">编辑</span>
              <span @click="remove(row)">删除</span>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <Modal v-model="showForm" hasCloseIcon>
      <template #header>凭证字设置</template>
      <Form ref="form" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="凭证字" prop="word">
          <Input type="text" v-model="form.word"/>
        </FormItem>
        <FormItem label="打印标题" prop="printTitle">
          <Input type="text" v-model="form.printTitle"/>
        </FormItem>
        <FormItem label="是否默认" prop="isDefault">
          <Radio v-model="form.isDefault" dict="defaultRadios"></Radio>
        </FormItem>
      </Form>
      <div class="text-center w-500px">
        <Button color="green" @click="submit" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
  </app-content>
</template>

<script>
const emptyForm = {
  "word": "",
  "printTitle": "",
  "isDefault": 0,
};

export default {
  name: 'VoucherWord',
  data() {
    return {
      datas: [],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ["word", "printTitle", "isDefault"]
      },
      showForm: false,
      loading: false
    };
  },
  watch: {
    showForm(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  methods: {
    loadList() {
      this.$api.setting.voucherWord.list().then(({data}) => {
        this.datas = data || [];
      })
    },
    submit() {
      if(this.form.id){
        //编辑
        if(this.form.isDefault){
          //当前编辑的这个设置为真
          this.datas.forEach(item =>{
            if(item.isDefault){
              if(this.form.id == item.id){
                //直接提交
                let validResult = this.$refs.form.valid();
                if (validResult.result) {
                  this.loading = true;
                  this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
                    this.loadList();
                    this.showForm = false;
                    this.loading = false;
                  }).catch(() => {
                    this.loading = false;
                  })
                }
              }else{
                let validResult = this.$refs.form.valid();
                if (validResult.result) {
                  this.loading = true;
                  this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
                    //现将item的设置为假
                    item.isDefault = false;
                    this.$api.setting.voucherWord['update'](item).then(() => {
                      this.loadList();
                      this.showForm = false;
                      this.loading = false;
                    }).catch(() => {
                      this.loading = false;
                    })
                  }).catch(() => {
                    this.loading = false;
                  })
                }

              }
            }
          })
        }else{
          let validResult = this.$refs.form.valid();
          if (validResult.result) {
            this.loading = true;
            this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
              this.loadList();
              this.showForm = false;
              this.loading = false;
            }).catch(() => {
              this.loading = false;
            })
          }
        }
      }else{
        //新增
        if(this.form.isDefault){
          //默认项目为真，进行检测
          this.datas.forEach(item =>{
            if(item.isDefault){
              item.isDefault = false;
              this.loading = true;
              let validResult = this.$refs.form.valid();
              if (validResult.result) {
                this.loading = true;
                this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
                  this.$api.setting.voucherWord['update'](item).then(() => {
                    this.loadList();
                    this.showForm = false;
                    this.loading = false;
                  }).catch(() => {
                    this.loading = false;
                  })
                }).catch(() => {
                  this.loading = false;
                })
              }
              this.showForm = false;
              this.loading = false;
            }
          })
        }else{
          let validResult = this.$refs.form.valid();
          if (validResult.result) {
            this.loading = true;
            this.$api.setting.voucherWord[this.form.id ? 'update' : 'save'](this.form).then(() => {
              this.loadList();
              this.showForm = false;
              this.loading = false;
            }).catch(() => {
              this.loading = false;
            })
          }
        }
      }
    },
    reset() {
      this.form = Object.assign({}, emptyForm)
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.setting.voucherWord.delete(data.id).then(() => {
          this.loadList();
        })
      })
    },
    edit(data) {
      this.form = Object.assign({}, data)
      this.showForm = true;
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>
